import { useValidate } from "formvalidation/hooks";
import type moment from "moment";
import React from "react";
import { is24Hour } from "utilities";
import { TimePicker } from "../components";

interface Props {
  value: moment.Moment
  onChange: (value: moment.Moment, submit: boolean) => void
  validatorKey: string
  autoFocus?: boolean

  // An entry cannot end without starting, so the start time becomes required once an end time is set
  isRequired: boolean
}

export const TimetableTimeInput = (props: Props) => {
  const validation = useValidate<HTMLDivElement, moment.Moment>({
    key: props.validatorKey,
    title: props.validatorKey,
    value: props.value,
    validate: async (value) => !props.isRequired || value != null,
    dependencies: [props.value, props.isRequired]
  });

  return <div ref={validation.ref}>
    <TimePicker
      error={validation.error.hasError}
      hourNotation={is24Hour() ? "24hr" : "12hr"}
      step={10}
      value={props.value}
      onChange={props.onChange}
      autoFocus={props.autoFocus}
      canBeEmpty={!props.isRequired}
    />
  </div>;
};
